import ArrowDown from '../../atoms/icons/arrowDown';
import Container from '../../atoms/container/channelArrowDownContainer';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { channelDown } from '../../../../shared/store/slices/channels.slice';

function ChannelDown() {
  const dispatch = useAppDispatch();
  return (
    <Container
      onClick={() => {
        dispatch(channelDown());
      }}
    >
      <ArrowDown />
    </Container>
  );
}

export default ChannelDown;
